import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=f8ecd19e&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=f8ecd19e&prod&scoped=true&lang=css"
import style1 from "./detail.vue?vue&type=style&index=1&id=f8ecd19e&prod&lang=css"
import style2 from "./detail.vue?vue&type=style&index=2&id=f8ecd19e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ecd19e",
  null
  
)

export default component.exports